import React from 'react'
import Link from '../actions/Link'

import Separator from '../helpers/Separator'
import Text, { SmallText } from './Text'

const LabelValue = ({ hideIfEmpty, label, value, children, ...props }) => {
  if (!!hideIfEmpty && !value && !children) return false

  return (
    <div className="labelValue">
      <SmallText color="dark3" size="xsmall">
        {label}
      </SmallText>
      {value && (
        <Text weight="600" {...props}>
          {value}
        </Text>
      )}
      {value && <Separator weight={1} />}
      {children}
      <Separator weight={1} />
    </div>
  )
}

export default LabelValue
